$(function () {
  $('.js_cart_submit_button').on('click', function (event) {
    event.preventDefault();
    // $('#cart_submit_modal').addClass('show_modal');
    $('#get_consent_modal').addClass('show_modal');
    $('.page-container').addClass('show_modal');
  });
  $('#cart_submit_disagree').on('click', function () {
    $('#cart_submit_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    $('.page-container').removeClass('show_modal');
  });
  $('#cart_submit_modal').on('click', function () {
    $('#cart_submit_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
  });

  /* 開梱設置注意モーダル */
  $('#select_unpacking').on('change', function (event) {
    if (
      document
        .getElementById('select_unpacking')
        .querySelector('option[id=unselect_packing_cost]').selected === true
    ) {
      $('#attention_modal').addClass('show_modal');
      $('#get_consent_modal').addClass('show_modal');
      $('.page-container').addClass('show_modal');
    }
  });

  $('#unboxing_disagree').on('click', function () {
    $('#attention_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    $('.page-container').removeClass('show_modal');
  });
  $('#unboxing_agree').on('click', function () {
    $('#attention_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    document
      .getElementById('select_unpacking')
      .querySelector('option[id=normal_packing_cost]').selected = true;
  });
});
